<template>
    <div class="group select-none"
        :class="[
            is_open ? 'bg-blue-50/30' : 'bg-transparent',
        ]"
        @click="toggleOpen"
    >
        <div class="folder-drag-header px-3 py-2 bg-transparent hover:bg-blue-50"
        >
            <div class="flex items-center justify-between">
                <div class="flex items-center leading-tight text-base font-semibold"
                    :class="is_open ? 'text-blue-600'
                        : (has_documents ? 'text-black group-hover:text-blue-600' : 'text-gray-warm-600 group-hover:text-blue-600')
                    "
                >
                    <!-- Disclosure Triangle -->
                    <div class="w-5 flex-none flex items-center justify-center mr-2">
                        <span v-if="is_open">
                            <chevron-down-icon size="16" class="text-gray-600" />
                        </span>
                        <span v-else>
                            <chevron-right-icon size="16" class="text-gray-400 group-hover:text-blue-600" />
                        </span>
                    </div>

                    <div class="pt-0.5">
                        {{ folder.name }}
                    </div>

                    <!-- Edit Button (only show when open and editable) -->
                    <div v-if="is_open && is_editable"
                         @click.stop="editFolder"
                         class="ml-6 pt-0.5 flex items-baseline font-normal text-xs text-gray-500 hover:text-blue-600 select-none"
                    >
                        <i class="far fa-edit mr-1.5"></i>
                        Edit Folder
                    </div>
                </div>

                <div class="flex items-center space-x-2 pr-1">
                    <!-- Document/Template Count Text -->
                    <div class="text-xs text-gray-500 mr-2">
                        {{ getCountText() }}
                    </div>

                    <!-- Drag Handle -->
                    <div v-if="!hide_drag_handle" 
                         class="cursor-move text-gray-400 hover:text-gray-600"
                         @click.stop
                         title="Drag to reorder">
                        <i class="fas fa-grip-vertical text-sm"></i>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="is_open">
            <document-subfolder
                name="Documents"
                :documents="documents"
                :folder_id="folder.id"
                :property_id="property_id"
                :has_active_docusign_user="has_active_docusign_user"
                :store_route="store_route"
                :has_templates="templates?.length"
                :selection_mode="selection_mode"
                :selected_documents="selected_documents"
                :hide_upload_button="hide_upload_button"
                :disable_contextual_menus="disable_contextual_menus"
                :is_editable="is_editable"
                @updatedDocument="updatedDocument"
                @documentUploaded="documentUploaded"
                @documentEdited="documentEdited"
                @documentDeleted="documentDeleted"
                @selection-changed="handleSelectionChanged"
            />

            <document-subfolder
                v-if="templates?.length"
                name="Form Templates"
                :is_template="true"
                :documents="templates"
                :folder_id="folder.id"
                :property_id="property_id"
                :has_active_docusign_user="has_active_docusign_user"
                :selection_mode="selection_mode"
                :selected_documents="selected_documents"
                :disable_contextual_menus="disable_contextual_menus"
                :is_editable="is_editable"
                @selection-changed="handleSelectionChanged"
            />
        </div>
    </div>
</template>

<script>
import { ChevronRightIcon, ChevronDownIcon } from 'vue-feather-icons';
import DocumentSubfolder from './document-subfolder.vue';

export default {
    components: {
        ChevronRightIcon,
        ChevronDownIcon,
        DocumentSubfolder,
    },

    props: {
        folder: {},
        property_id: {},
        documents: {},
        templates: {},
        has_active_docusign_user: {},
        store_route: {},
        folder_to_expand: {},
        selection_mode: { default: false },
        selected_documents: { default: () => [] },
        hide_upload_button: { default: false },
        hide_drag_handle: { default: false },
        disable_contextual_menus: { default: false },
        is_editable: { default: true },
    },

    data() {
        return {
            is_open: false,
        }
    },

    computed: {
        document_count() {
            return this.documents?.length;
        },
        template_count() {
            return this.templates?.length;
        },
        has_documents() {
            return this.document_count || this.template_count;
        },
    },

    methods: {
        toggleOpen() {
            this.is_open = ! this.is_open;
        },
        getCountText() {
            const parts = [];

            if (this.document_count > 0) {
                const docText = this.document_count === 1 ? 'document' : 'documents';
                parts.push(`${this.document_count} ${docText}`);
            }

            if (this.template_count > 0) {
                const templateText = this.template_count === 1 ? 'form template' : 'form templates';
                parts.push(`${this.template_count} ${templateText}`);
            }

            return parts.join(', ');
        },
        updatedDocument(e) {
            this.$emit('updatedDocument', e);
        },
        documentEdited(updatedDocument) {
            this.$emit('documentEdited', updatedDocument);
        },
        documentDeleted(id) {
            this.$emit('documentDeleted', id);
        },
        documentUploaded(document) {
            this.$emit('documentUploaded', document);
        },
        editFolder() {
            this.$emit('editFolder', this.folder);
        },
        handleSelectionChanged(selected) {
            this.$emit('selection-changed', selected);
        }
    },

    watch: {
        folder_to_expand(value, old_value) {
            if (value && value == this.folder.id) {
                this.is_open = true;
                this.$emit('expanded_folder', this.folder.id);
            }
        },
    },
}
</script>
